import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import ExperienceEntry from '../../../../../../models/v2/experience_entry';

// Base
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Listing from './experience_entries/listing';
import Loading from './experience_entries/loading';

export default class ExperienceEntries extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    experienceEntries: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    let url = `/api/v2/profiles/${profile.id}/experience_entries`;
    if (!isEmptyObject(persona)) {
      url = `/api/v2/personas/${persona.id}/experience_entries`;
    }
    ExperienceEntry
      .url(url)
      .sort('start_date DESC')
      .all(false)
      .then((experienceEntries) => {
        this.setState({
          experienceEntries,
          loading: false,
        })
    })
  }

  render() {
    const { persona } = this.props;
    const { loading, experienceEntries } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Row className='margin-top-15 margin-bottom-10' nested>
        <Col s={12} className='med-font dark margin-bottom-10'>
          Experience
        </Col>
        {
          experienceEntries.map((experienceEntry) => (
            <Col s={12} key={experienceEntry.id}>
              <Listing {...{
                persona,
                experienceEntry,
                experienceEntries,
              }} />
            </Col>
          ))
        }
      </Row>
    )
  }
}